import { State, selectAppPreview } from '../../index'
export const selectCampaignInformation = (state: State) => selectAppPreview(state).campaignInformation
